import { render } from "./PrincipalDependantClientComponent.vue?vue&type=template&id=1f47b616&scoped=true"
import script from "./PrincipalDependantClientComponent.vue?vue&type=script&lang=js"
export * from "./PrincipalDependantClientComponent.vue?vue&type=script&lang=js"

import "./PrincipalDependantClientComponent.vue?vue&type=style&index=0&id=1f47b616&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f47b616"]])

export default __exports__